import Flex from "components/Flex";
import { ageAtDate } from "helpers/ageAtDate";
import { Dispatch, FC } from "react";
import { CaseInfo } from "generated/graphql";
import PDatePicker from "../PDatePicker";

const MIN_DATE = new Date(Date.UTC(1900, 0));
const MAX_DATE = new Date(Date.UTC(2100, 0));

export interface DateCellProps {
  value: Date | undefined;
  setValue: Dispatch<Date | undefined>;
  error?: string;
  setError?: (error: string | undefined) => void;
  disabled?: boolean;
  required: boolean;
  caseInfo?: CaseInfo;
  inputVariant?: "standard" | "filled" | "outlined";
  label: string | undefined;
  variant?: "dense" | "normal";
}

export const DateCell: FC<DateCellProps> = ({
  value,
  setValue,
  disabled,
  caseInfo,
  variant,
  inputVariant,
  label,
  required,
  error,
  setError,
}) => {
  const dob = caseInfo?.dateOfBirth;
  const dobDate = dob ? new Date(dob) : undefined;
  const age = value && dobDate ? ageAtDate(dobDate, value) : undefined;
  return (
    <Flex>
      <PDatePicker
        disabled={disabled}
        required={required}
        inputVariant={inputVariant}
        label={label}
        date={value}
        error={error}
        setError={setError}
        minDate={MIN_DATE}
        maxDate={MAX_DATE}
        setDate={setValue}
        helperText={variant !== "dense" ? (age !== undefined ? `Age at date: ${age}` : "") : undefined}
      />
    </Flex>
  );
};
